import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { ResponseTerminalDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';
import { handleDuplicates, removeUndefined } from 'utils/array-helpers';
import { PaginatedResponse } from 'types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { BaseQueryParams } from 'types/base-query-params';
import { TerminalStatus } from '../constants/status';
import { ResponseAccountDto } from 'features/account/types/dtos';
import { checkError, fetchResponse } from 'utils/api-helpers';
import { formatDate } from 'utils/date-helpers';

export type TerminalsWithJoinQueryParams = BaseQueryParams & {
    name?: string;
    status?: TerminalStatus;
    deviceId?: string;
    accountId?: string;
    createdAt?: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseTerminalDto>, TerminalsWithJoinQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const terminalsResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.TERMINALS, _arg));

            if (terminalsResponse.error) {
                return { error: terminalsResponse.error };
            }
            const terminals = terminalsResponse.data as PaginatedResponse<ResponseTerminalDto>;
            const accountIds = removeUndefined(handleDuplicates(terminals.content.map((account) => account.accountId)));
            const accountsResponse = await fetchResponse(APP_ENDPOINTS.ACCOUNTS, accountIds, fetchWithBQ);
            const accountsError = checkError(accountsResponse);
            if (accountsError) return accountsError;
            const accounts = accountsResponse.data as PaginatedResponse<ResponseAccountDto>;

            terminals.content = terminals.content.map((terminal) => {
                const accountEmail = accounts.content.find((account) => {
                    return account.id === terminal.accountId;
                })?.email;

                const createdAt = formatDate(terminal.createdAt);

                return {
                    ...terminal,
                    createdAt,
                    accountEmail,
                };
            });

            return {
                data: terminals,
            };
        },
        providesTags: [{ type: 'terminals-with-join', id: 'GET-JOIN' }],
    });
